// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"3793":"03162dd0","6773":"239d3ea4","9525":"a53ee2a7"}[chunkId] + ".js";
};